// 赛道选择列表
export const trackSelectLists = [
  {
    id: 1,
    label: '文学艺术',
    selected: false,
  },
  {
    id: 2,
    label: '军事军武',
    selected: false,
  },
  {
    id: 3,
    label: '教育',
    selected: false,
  },
  {
    id: 4,
    label: '政治时事',
    selected: false,
  },
  {
    id: 5,
    label: '环境能源',
    selected: false,
  },
  {
    id: 6,
    label: '财政金融',
    selected: false,
  },
  {
    id: 7,
    label: '文学艺术',
    selected: false,
  },
  {
    id: 8,
    label: '餐饮美食',
    selected: false,
  },
  {
    id: 9,
    label: '社会民生',
    selected: false,
  },
  {
    id: 10,
    label: '情感心理',
    selected: false,
  },
  {
    id: 11,
    label: '体育健身',
    selected: false,
  },
  {
    id: 12,
    label: '母婴育儿',
    selected: false,
  },
  {
    id: 13,
    label: '情感心理',
    selected: false,
  },
  {
    id: 14,
    label: '职场',
    selected: false,
  },
  {
    id: 15,
    label: '母婴育儿',
    selected: false,
  },
  {
    id: 16,
    label: '科学科普',
    selected: false,
  },
  {
    id: 17,
    label: '科技',
    selected: false,
  },
  {
    id: 18,
    label: '农林牧渔',
    selected: false,
  },
  {
    id: 19,
    label: '互联网',
    selected: false,
  },
  {
    id: 20,
    label: '娱乐休闲',
    selected: false,
  },
  {
    id: 21,
    label: '动物宠物',
    selected: false,
  },
  {
    id: 22,
    label: '娱乐休闲',
    selected: false,
  },
  {
    id: 23,
    label: '法律司法',
    selected: false,
  },
  {
    id: 24,
    label: '其他',
    selected: false,
  },
];

export const trackSelectFoShanLists = [
  {
    id: 1,
    label: '电器',
    selected: false,
  },
  {
    id: 2,
    label: '玉器',
    selected: false,
  },
  {
    id: 3,
    label: '皮鞋',
    selected: false,
  },
  {
    id: 4,
    label: '内衣',
    selected: false,
  },
  {
    id: 5,
    label: '金属',
    selected: false,
  },
  {
    id: 6,
    label: '电子',
    selected: false,
  },
  {
    id: 7,
    label: '医药',
    selected: false,
  },
  {
    id: 8,
    label: '汽车',
    selected: false,
  },
  {
    id: 9,
    label: '铝材',
    selected: false,
  },
  {
    id: 10,
    label: '五金',
    selected: false,
  },
  {
    id: 11,
    label: '新能源',
    selected: false,
  },
  {
    id: 12,
    label: '纺织',
    selected: false,
  },
  {
    id: 13,
    label: '陶瓷',
    selected: false,
  },
  {
    id: 14,
    label: '米酒',
    selected: false,
  },
  {
    id: 15,
    label: '家具',
    selected: false,
  },
  {
    id: 16,
    label: '医卫',
    selected: false,
  },
  {
    id: 17,
    label: '食品',
    selected: false,
  },
  {
    id: 18,
    label: '塑料',
    selected: false,
  },
  {
    id: 19,
    label: '玻璃',
    selected: false,
  },
  {
    id: 20,
    label: '饮料',
    selected: false,
  },
  {
    id: 21,
    label: '住宅',
    selected: false,
  },
  {
    id: 22,
    label: '家具',
    selected: false,
  },
  {
    id: 23,
    label: '农产品加工',
    selected: false,
  },
  {
    id: 24,
    label: '化工',
    selected: false,
  },
  {
    id: 25,
    label: '机械装备',
    selected: false,
  },
  {
    id: 26,
    label: '食品加工',
    selected: false,
  },
  {
    id: 27,
    label: '童装',
    selected: false,
  },
  {
    id: 28,
    label: '不锈钢',
    selected: false,
  },
  {
    id: 29,
    label: '珠宝',
    selected: false,
  },
  {
    id: 30,
    label: '机械模具',
    selected: false,
  },
  {
    id: 31,
    label: '木工机械',
    selected: false,
  },
  {
    id: 32,
    label: '铝塑管',
    selected: false,
  },
  {
    id: 33,
    label: '涂料',
    selected: false,
  },
  {
    id: 34,
    label: '电池研发',
    selected: false,
  },
  {
    id: 35,
    label: '钢铁',
    selected: false,
  },
  {
    id: 36,
    label: '其他',
    selected: false,
  },
];
// 角色选择列表
export const roleSelectLists = [
  {
    id: 1,
    active: false,
    img: require('@/assets/images/ai-action/Blink.png'),
    title: '自媒体工作者',
  },
  {
    id: 2,
    active: false,
    img: require('@/assets/images/ai-action/Bunny-Man.png'),
    title: '市场营销/文案策划',
  },
  {
    id: 3,
    active: false,
    img: require('@/assets/images/ai-action/Dee.png'),
    title: '编辑/记者',
  },
  {
    id: 4,
    active: false,
    img: require('@/assets/images/ai-action/Graggle.png'),
    title: '小微企业/个体私营',
  },
  {
    id: 5,
    active: false,
    img: require('@/assets/images/ai-action/Peppe.png'),
    title: '职场写作',
  },
  {
    id: 6,
    active: false,
    img: require('@/assets/images/ai-action/Gill.png'),
    title: '其他',
  },
];

export const defaultTopicResult = [
  {
    id: 1,
    title: '数字游民生活全揭秘:如何利用远程工作实现地理和财务的双重自由!',
    content:
      '建议从数字游民生活方式的吸引力和实现难度的角度切入，阐述了通过掌握远程工作的能力和策略、选择适合的在线工作平台和项目、建立高效的工作与生活的平衡，从而表达出在全球化背景下，借助远程工作可以实现地理和财务的双重自由的观点。内容上:1、分析当前职场趋势，说明为何远程工作成为越来越多年轻人的选择;2、提供实用的远程工作技巧和策略，如时间管理、沟通协作等;3、分享成功的数字游民案例，展示他们是如何实现梦想生活的。',
  },
  {
    id: 2,
    title: '数字游民必看:如何用5种在线策略月入过万，告别朝九晚五!',
    content:
      '建议从数字游民的生活方式和追求自由、灵活工作的愿望角度切入，阐述了通过建立多元化收入来源(如自由职业、在线课程、电子商务等)实现财务自由的具体方法和策略，从而表达全球化背景下借助远程工作实现地理和财务自由的观点。内容上:1、介绍数字游民概念及其吸引力，说明为什么越来越多的人选择这种生活方式;2、详细分析5种可行的在线收入模式，包括各自的优势、劣势及风险评估，并提供成功案例分享;3、提供心态调整指南，帮助读者摆脱传统办公观念的束缚，鼓励他们根据自己的兴趣和技能选择合适的收入方式。',
  },
  {
    id: 3,
    title: '数字游民必看!解锁全球远程工作，实现财务自由的秘密武器',
    content:
      '建议从全球化背景下年轻职场人士追求工作和生活方式转变的角度切入，阐述了如何通过远程工作实现地理和财务自由的实用策略、成功案例分析及必要的心态调整，从而表达在现代职场中，拥抱变化、灵活适应是走向成功的关键。内容上:1、介绍数字游民生活方式的兴起背景及其对传统工作模式的挑战;2、详细讲解实施远程工作需要准备的技能、工具以及如何管理时间和生产力;3、通过真实案例展示不同行业和领域的数字游民如何成功实现梦想生活;4、讨论在成为数字游民过程中可能遇到的心态挑战及调适方法。',
  },
  {
    id: 4,
    title: '远程工作秘籍大揭秘:如何成为数字游民，享受地理和财务自由',
    content:
      '建议从全球化背景下年轻职场人士对工作和生活方式的新期待入手，阐述了数字游民的生活方式及其实现路径，从而表达追求自由、灵活的工作方式是可行且值得推崇的观点。内容上:1、分析当前全球化背景下，远程工作趋势的兴起以及它为个人带来的地理和财务自由的可能性;2、提供实用策略，如如何选择适合远程工作的行业和岗位，提升自身技能以适应远程工作环境，以及如何利用网络资源建立个人品牌等:3、通过案例分析，介绍成功转型为数字游民的个人故事，包括他们如何克服挑战，调整心态以及最终实现梦想生活的过程;4、给出心态调整的建议，比如如何应对远程工作可能带来的孤独感，如何保持高效和自律，以及如何平衡工作和生活的关系等。',
  },
];

export interface HotspotItem {
  id: string;
  title: string;
  content: string;
  createTime: string;
}

export interface AiTrack {
  id: number;
  selected: boolean;
  projectName: string;
}
